import React from 'react'
import Main from '../../Main'
import {ajaxGet} from 'api/explus-api'
import reactDisplayHtml from 'utils/react-display-html'

// const ProjectSingle = props => {
class ProjectSingle extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      project: ''
    }
  }

  getProject(get) {
    let props = this.props

    ajaxGet('web/projects/' + props.match.params.projectId).then(data => {
      this.setState({project: data[0]})
    })
  }

  componentDidMount() {
    this.getProject()
  }

  render() {
    return (
      <Main>
        <div className="row">
          <div class="col-md-8">
            <div className="island">
              <h1>{this.state.project.project_name}</h1>
              <div dangerouslySetInnerHTML={reactDisplayHtml(this.state.project.full_description)}>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="island">
              <img className="img-responsive" src={this.state.project.map_url} alt="map"/>
            </div>
          </div>
        </div>

        <button className="btn margin-top-small" onClick={(e) => {e.preventDefault(); this.props.history.goBack()}}>
        <i className="fa fa-chevron-left" aria-hidden="true"></i> Go back
        </button>
      </Main>
    )
  }
}

export default ProjectSingle
